// ========================================
// INTERFACES PARA ENTREGA DE CESTA BÁSICA
// ========================================

/**
 * Status da entrega de cesta básica
 */
export enum FoodBasketStatus {
    PENDING = 'PENDING', // Pendente
    DELIVERED = 'DELIVERED', // Entregue
    SIGNED = 'SIGNED', // Assinado
    CANCELLED = 'CANCELLED', // Cancelada
}

/**
 * Interface base para Entrega de Cesta Básica
 */
export interface IFoodBasket {
    readonly id: string;
    readonly employeeName: string;
    readonly employeeId: string;
    readonly withdrawalDate: Date;
    readonly servicePost: string;
    readonly servicePostId?: string;
    readonly referenceMonth: number; // 1-12
    readonly referenceYear: number;
    readonly signature?: string; // URL ou ID da assinatura digital
    readonly signatureProvider?: string; // Nome do provedor de assinatura
    readonly status: FoodBasketStatus;
    readonly notes?: string;
    readonly companyId: string;
    /** Auditoria — só data na UI */
    readonly viewedAt?: string | Date | null;
    readonly printedAt?: string | Date | null;
    readonly createdAt: Date;
    readonly updatedAt: Date;
    readonly deletedAt?: Date;
    readonly createdBy?: string;
    readonly updatedBy?: string;
}

/**
 * DTO para criação de Entrega de Cesta Básica
 */
export interface ICreateFoodBasketDto {
    employeeName: string;
    employeeId: string;
    withdrawalDate: Date | string;
    servicePost: string;
    servicePostId?: string;
    referenceMonth: number;
    referenceYear: number;
    signature?: string;
    signatureProvider?: string;
    status: FoodBasketStatus;
    notes?: string;
}

/**
 * DTO para atualização de Entrega de Cesta Básica
 */
export interface IUpdateFoodBasketDto extends Partial<ICreateFoodBasketDto> {
    id: string;
}

/**
 * Interface para filtros de busca
 */
export interface IFoodBasketFilters {
    page?: number;
    limit?: number;
    search?: string;
    employeeId?: string;
    servicePost?: string;
    referenceMonth?: number;
    referenceYear?: number;
    status?: FoodBasketStatus;
    companyId?: string;
}







